const translations = {
  common: {
    login: "Login",
    logout: "Logout",
    email: "Email",
    password: "Password",
    dashboard: "Dashboard",
    profile: "Profile",
    settings: "Settings",
    language: "Language",
    training: "Training"
  },
  navbar: {
    appName: "Voice Victor"
  },
  dashboard: {
    authority: "Authority",
    pitchVariation: "Pitch Variation",
    speechRate: "Energy Variation",
    keyMetrics: "Key Metrics",
    improvementPoints: "Improvement Points",
    companyMetrics: "Company Metrics",
    leaderboard: "Leaderboard",
    managementDashboard: "Management Dashboard",
    teamOverview: "Team Members",
    filter: "Filter",
    filterTeam: "Filter Team Members",
    voiceScoreRange: "Voice Score",
    showFollowedAgents: "Show only followed agents",
    resetFilters: "Reset filters",
    agentsShown: "{{count}} agents shown",
    agent: "Agent",
    voiceScore: "Voice Score",
    development: "Development",
    developmentOverTime: "Development over time",
    actions: "Actions",
    positive: "Positive",
    stable: "Stable",
    declining: "Declining",
    following: "Following",
    follow: "Follow",
    overview: "Overview",
    backToOverview: "Back to overview",
    talkRatio: "Talk ratio",
    na: "N/A",
    tr: "TR",
    avgDuration: "Avg. Duration",
    avgCallDuration: "Average call duration",
    competenceProfile: "Competence Profile",
    yourVoiceProfile: "Your voice profile",
    insightAndImprovement: "Insight & Improvement",
    highPriority: "High priority",
    mediumPriority: "Medium priority",
    lowPriority: "Low priority",
    notifications: "Notifications",
    notificationsComingSoon: "Notification center coming soon...",
    selectCategory: "Select a category from the menu",
    agents: "Agents",
    alerts: "Alerts",
    noAgentsMatchFilters: "No agents match the selected filters",
    moreListening: "More listening",
    moreTalking: "More talking",
    improvementOpportunities: "Improvement Opportunities",
    best30Seconds: "Best 30 seconds (last 10 calls)",
    worst30Seconds: "Worst 30 seconds (last 10 calls)",
    seeAllImprovements: "See all improvement opportunities",
    comingSoon: "Coming Soon",
    featureNotAvailable: "This feature is not available yet"
  },
  race: {
    title: "Race",
    raceTo100: "Race to 100",
    topScore: "Top Score",
    biggestImprovement: "Biggest Improvement",
    score: "Score",
    from: "From",
    challengeColleague: "Challenge a Colleague",
    chooseColleague: "Choose a colleague to challenge to improve their voice score:",
    challenge: "Challenge",
    noUserData: "No user data found. Add some voice scores to see race data.",
    yourPosition: "Your position: #{{rank}} of {{total}} participants",
    voiceScore: "Voice Score",
    improvement: "Improvement",
    raceTab: "Race",
    improvementTab: "Improvement",
    challengeTab: "Challenge"
  },
  login: {
    title: "Voice Victor - Login",
    invalidRole: "Invalid user role",
    profileNotFound: "User profile not found. Please contact the administrator.",
    failedToFetch: "Could not fetch user profile. Security rules may be misconfigured.",
    invalidCredentials: "Incorrect email or password.",
    userNotFound: "No user found with this email.",
    wrongPassword: "Incorrect password.",
    tooManyAttempts: "Too many failed attempts. Please try again later."
  },
  errorMessages: {
    loginFailed: "Login error: "
  },
  questions: {
    sectionTitle: "Questions & Partial Accepts",
    hvQuestions: "WH-Questions",
    hvQuestionsDescription: "Questions that uncover who, what, when, where, why, and how to understand the customer's needs and situation.",
    partialAccepts: "Partial Accepts",
    partialAcceptsDescription: "Questions designed to secure incremental agreements",
    moreQuestions: "more questions"
  },
  training: {
    title: "Voice Training",
    description: "Practice your communication with our AI training assistant",
    startTraining: "Start Training",
    stopTraining: "Stop Training",
    starting: "Starting...",
    stopping: "Stopping...",
    connecting: "Connecting to training session...",
    connected: "Connected",
    agentConnected: "AI assistant connected",
    browserNotSupported: "Your browser doesn't support all features required for training",
    selectScenario: "Select Scenario",
    howItWorks: "How it works",
    step1: "Select a training scenario from the dropdown menu",
    step2: "Click 'Start Training' to begin the session",
    step3: "Grant microphone access when your browser asks for it",
    step4: "The conversation is automatically recorded and uploaded to Firebase after the session"
  }
};

export default translations; 